<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    if (icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(<i class={[icon, 'sub-el-icon'] } title={title}/>)
      } else {
        vnodes.push(<svg-icon icon-class={icon} title={title}/>)
      }
    }

    if (title) {
      vnodes.push(<span class='el-submenu-span omit-1' slot='title' title={title}>{(title)}</span>)
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}
.el-submenu-span{
  padding: 0 20px;
}
</style>
